export function ensureTrailingSlash(value: string): string {
  if (!value || value.endsWith('/')) {
    return value;
  }
  return `${value}/`;
}

export function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

export function prefixPath(base: string, path: string): string {
  if (!base) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
